import {Component, Input, OnInit} from '@angular/core';
import {FormGroup} from '@angular/forms';
import {Step2} from '../../../../shared/models/component-messages/simp_in/step2';
import {TypeOuiNon} from '../models/TypeOuiNon';

@Component({
  selector: 'app-type-oui-non',
  templateUrl: './type-oui-non.component.html'
})
export class TypeOuiNonComponent implements OnInit {
  @Input() uid = '';
  public current_uid = 'TypeOuiNon';
  @Input() parentForm: FormGroup;
  @Input() disabled: boolean;
  @Input() value: TypeOuiNon;
  @Input() label: String;

  public step2 = new Step2();

  public radioButtonValue: string;
  public radioButtonCtrlName: string;

  constructor() {
  }

  public ngOnInit() {

    if (this.value != null && this.value.oui) {
      this.radioButtonValue = 'Oui';
    } else if (this.value != null && this.value.non) {
      this.radioButtonValue = 'Non';
    } else {
      this.radioButtonValue = null;
    }
    this.radioButtonCtrlName = this.getUid() + '_SepAtt_oui';
  }

  getUid() {
    return this.uid + '_SepSep_' + this.current_uid;
  }
}
